import merge from 'lodash/merge';
import { baseConfig } from 'merchants/identance';
import { IConfig } from 'merchants/types/IConfig';
import * as merchant from 'utils/merchant';
import { images } from './images';
import { themeKuna } from './theme';
import { i18n } from './locales'

const { backUrl, workingMode, product = '' } = merchant.getSettings();


const customConfig = {
  backUrl,
  workingMode,
  product,
  requestToken: merchant.getToken(),
  features: {
    breadcrumbsInHeader: false,
    breadcrumbs: true,
    exitBtn: true,
  },
  i18n,
  images,
  theme: {
    name: 'kuna',
    config: themeKuna
  },
};

export const config: IConfig  = merge({}, baseConfig, customConfig);
